module.exports = __webpack_public_path__ + "assets/img/zoom-in.8cd3efb4.svg";